export class HojaDeConsulta {
  numeroExpediente: string;
  cip: string;
  visita: string;
  cita: string;
  orden: string;
  hora: string;
  modo: string;
  presente: boolean;
  estado: string;
  edad: string;
  nombre: string;
  apellidos: string;
  acto: string;
  it: string;
  detalles: string;
  tipoCita: string;
  sexo: string;
  fechaNacimiento: string;
  dni: string;
  tipoConsulta: string;
}



// WEBPACK FOOTER //
// ./src/models/hojadeconsulta.ts